import { useEffect } from 'react';

const SITE = 'AgendaPro';

export function usePageMeta(title: string, description?: string, canonicalPath?: string, imageUrl?: string | null): void {
  useEffect(() => {
    document.title = `${title} · ${SITE}`;
    if (description) setMeta('name', 'description', description);
    setMeta('property', 'og:title', `${title} · ${SITE}`);
    if (description) setMeta('property', 'og:description', description);
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:site_name', SITE);
    setMeta('name', 'twitter:card', 'summary_large_image');
    if (imageUrl) {
      setMeta('property', 'og:image', imageUrl);
      setMeta('name', 'twitter:image', imageUrl);
    }
    if (canonicalPath) {
      const url = new URL(canonicalPath, window.location.origin).toString();
      setMeta('property', 'og:url', url);
      let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.rel = 'canonical';
        document.head.appendChild(link);
      }
      link.href = url;
    }
  }, [title, description, canonicalPath, imageUrl]);
}

function setMeta(attr: 'name' | 'property', key: string, content: string): void {
  let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}

export function jsonLd(data: Record<string, unknown>): string {
  return JSON.stringify(data);
}
